// extracted by mini-css-extract-plugin
export default {"footer":"HistoryItem_footer__+FhGH"};